export const comments_5689024 = {"data":{"data":[],"links":{}}}